import { ValidatorFn, Validators } from '@angular/forms';
import { AppValidators } from 'src/app/common/appValidators';

export const RequiredValidatorFunction: ValidatorFn[] = [Validators.required];
export const CredentialValidatorsFunctions: ValidatorFn[] = [AppValidators.noSpace];
export const EmailCredentialValidatorsFunctions: ValidatorFn[] = CredentialValidatorsFunctions.concat([
  AppValidators.email,
]);
export const GuidCredentialValidatorsFunctions: ValidatorFn[] = CredentialValidatorsFunctions.concat([
  AppValidators.guid,
]);
export const CertificateThumbprintCredentialValidatorsFunctions: ValidatorFn[] = CredentialValidatorsFunctions.concat([
  AppValidators.certificateThumbprint,
]);
export const CertificatePrivateKeyCredentialValidatorsFunctions: ValidatorFn[] = [AppValidators.certificatePrivateKey];
export const SalesforceInstanceUrlCredentialValidatorsFunctions: ValidatorFn[] = CredentialValidatorsFunctions.concat([
  AppValidators.salesforceInstanceUrl,
]);
export const serviceNowInstanceUrlCredentialValidatorsFunctions: ValidatorFn[] = CredentialValidatorsFunctions.concat([
  AppValidators.serviceNowInstanceUrl,
]);
export const ChatGptEnterpriseApiKeyCredentialValidatorsFunctions: ValidatorFn[] = CredentialValidatorsFunctions.concat(
  [AppValidators.chatGptEnterpriseApiKey]
);
export const AmazonBedrockIamRoleArnCredentialValidatorsFunctions: ValidatorFn[] = CredentialValidatorsFunctions.concat(
  [AppValidators.amazonBedrockIamRoleArn]
);
export const BudibaseTenantIdCredentialValidatorsFunctions: ValidatorFn[] = CredentialValidatorsFunctions.concat([
  AppValidators.budibaseTenantId,
]);
export const BudibaseCustomDomainCredentialValidatorsFunctions: ValidatorFn[] = CredentialValidatorsFunctions.concat([
  AppValidators.budibaseCustomDomain,
]);
export const BudibaseApiPathPrefixCredentialValidatorsFunctions: ValidatorFn[] = CredentialValidatorsFunctions.concat([
  AppValidators.budibaseApiPathPrefix,
]);
export const AirtablePersonalAccessTokenCredentialValidatorsFunctions: ValidatorFn[] = RequiredValidatorFunction.concat(
  CredentialValidatorsFunctions
).concat([AppValidators.airtablePersonalAccessToken]);
export const AirtableTenantIdCredentialValidatorsFunctions: ValidatorFn[] = CredentialValidatorsFunctions.concat([
  AppValidators.airtableTenantId,
]);
export const MtlsClientCertificateCredentialValidatorsFunctions: ValidatorFn[] = [AppValidators.mtlsClientCertificate];
export const MtlsClientPrivateKeyCredentialValidatorsFunctions: ValidatorFn[] = [AppValidators.certificatePrivateKey];
export const MtlsCaCertificateCredentialValidatorsFunctions: ValidatorFn[] = [AppValidators.mtlsClientCertificate];
